<template>
  <form @submit.prevent="save" autocomplete="off">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-4">
        <b-field>
          <form-input :label="`${$t('admin.employee_name')} *`" v-model="form.name"></form-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-input :label="`${$t('admin.last_name')} *`" v-model="form.last_name"></form-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-input :label="$t('admin.patronymic')" v-model="form.patronymic"></form-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <form-input :label="$t('admin.initials')" v-model="form.initials"></form-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <form-input :label="$t('admin.inn')" v-model="form.inn"></form-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <form-select :label="$t('admin.gender')" v-model="form.gender">
            <option value="male">{{ $t('admin.male') }}</option>
            <option value="female">{{ $t('admin.female') }}</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <form-datepicker :label="$t('admin.birthday')" v-model="form.birthday"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-input :label="$t('admin.mobile_phone')" v-model="form.mobile_phone"></form-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-input :label="$t('admin.work_phone')" v-model="form.work_phone"></form-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-datepicker :label="$t('admin.hired_date')" v-model="form.hired_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-input :label="$t('admin.workplace_office')" v-model="form.workplace_office"></form-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-input :label="$t('admin.workplace_level')" v-model="form.workplace_level"></form-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-input :label="$t('admin.workplace_cabinet_number')"
                      v-model="form.workplace_cabinet_number"></form-input>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field>
          <form-textarea :label="$t('admin.bio')" v-model="form.bio"></form-textarea>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-select :label="`${$t('admin.department')} *`" v-model="form.department" @change="form.position = null">
            <option v-for="department in relations.departments" :value="department.id">
              {{ department.name }}
            </option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-select :label="`${$t('admin.position')} *`" v-model="form.position">
            <option v-for="position in positions" :value="position.id">
              {{ position.name }}
            </option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-3" v-if="form.is_dismissed">
        <b-field>
          <form-datepicker :label="$t('admin.dismissal_date')" v-model="form.dismissal_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-2">
        <b-switch class="mt-15" v-model="form.is_dismissed">{{ $t('admin.is_dismissed') }}</b-switch>
      </div>
      <div class="column is-12">
        <h1 class="title is-6 mt-10">{{ $t('admin.userData') }}</h1>
      </div>
      <template v-if="!data">
        <div class="column is-3">
          <b-field>
            <form-input autocomplete="off" :label="`${$t('admin.login')} *`" v-model="form.user.username"></form-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field>
            <form-input autocomplete="new-password" type="password" :label="`${$t('admin.password')} *`" v-model="form.user.password"></form-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field>
            <form-input autocomplete="new-password" type="password" :label="`${$t('admin.password2')} *`" v-model="form.user.password2"></form-input>
          </b-field>
        </div>
      </template>
      <div class="column is-3">
        <b-field>
          <form-select :label="$t('employees.language')" v-model="form.locale">
            <option value="ru">Русский</option>
            <option value="uz">O`zbekcha</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-12" v-if="form.user">
        <b-select class="p-0"
                  multiple
                  native-size="6"
                  v-model="form.user.groups">
          <option v-for="group in relations.groups" :value="group.id">{{ group.name }}</option>
        </b-select>
        <Executors v-if="data"
                   :employees="form.executors"
                   :show-state="false"
                   :editable="true"
                   :canDeleteAny="true"
                   :scope-all="false"
                   @add="addExecutor"
                   @remove="removeExecutor">
        </Executors>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState} from 'vuex'
  import {prepareDate} from '@/utils'
  import EmployeeSelect from '@/components/EmployeeSelect'
  import Executors from '@/components/Executors'

  const defaultData = {
    name: '',
    last_name: '',
    patronymic: '',
    initials: '',
    inn: '',
    gender: 'male',
    birthday: null,
    mobile_phone: '',
    work_phone: '',
    hired_date: null,
    dismissal_date: null,
    is_dismissed: false,
    workplace_office: null,
    workplace_level: null,
    workplace_cabinet_number: null,
    bio: '',
    department: null,
    position: null,
    locale: 'ru',
    user: {
      username: '',
      password: '',
      password2: '',
      groups: []
    },
    executors: []
  }

  export default {
    props: ['data', 'editMode'],
    components: {EmployeeSelect, Executors},
    data() {
      return {
        form: this.data || {...defaultData, user: {...defaultData.user}},
        isEdit: this.editMode || false,
        errors: []
      }
    },
    methods: {
      validate() {
        this.errors = []
        if (this.form.name === '' || this.form.last_name === '' || this.form.department === null || this.form.position === null) {
          this.errors.push(this.$t('interface.requiredFields'))
        } else if (!this.data && (this.form.user.login === '' || this.form.user.password === '' || this.form.user.password2 === '')) {
          this.errors.push(this.$t('interface.requiredFields'))
        } else if (!this.data && (this.form.user.password !== this.form.user.password2)) {
          this.errors.push(this.$t('admin.passwordsWrong'))
        }
        return this.errors.length === 0
      },
      save() {
        if (this.validate()) {
          if (this.data) this.form = {...this.form, user: {groups: this.form.user.groups}, photo: null}
          this.$emit('save', {
            ...this.form,
            birthday: this.form.birthday ? prepareDate(this.form.birthday) : null,
            hired_date: this.form.hired_date ? prepareDate(this.form.hired_date) : null,
            dismissal_date: this.form.dismissal_date ? prepareDate(this.form.dismissal_date) : null
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      },
      addExecutor(executorId) {
        this.$store.dispatch('Moderator/addExecutor', {
          executorId,
          employeeId: this.$route.params.id
        }).then(executor => {
          this.form.executors = [
            ...this.form.executors,
            executor
          ]
        })
      },
      removeExecutor(executorId) {
        this.$store.dispatch('Moderator/removeExecutor', {
          executorId,
          employeeId: this.$route.params.id
        }).then(() => {
          this.form.executors = this.form.executors.filter(executor => executor.id !== executorId)
        })
      }
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      positions() {
        return this.form.department ? this.relations.departments
          .filter(department => department.id === parseInt(this.form.department))[0].positions : []
      }
    },
    watch: {
      data(data) {
        this.form = data
      },
      'form.is_dismissed'(is) {
        if (is) this.form.dismissal_date = new Date()
        else this.form.dismissal_date = null
      }
    }
  }
</script>
